import * as React from "react";
const TableFooter = ({
  children,
  dataTest
}) => /*#__PURE__*/React.createElement("tfoot", {
  className: "bg-cloud-normal w-full whitespace-nowrap font-bold",
  "data-test": dataTest
}, children);
export default TableFooter;